import { creditcardList } from './tableColumns'
import FilterComponent from './fragments/ListFilter'
// import CardImport from './modals/History/'
import HistoryModal from 'components/HistoryModal'

import {
	getCreditClient,
	listCreditClients,
	updateCreditClient,
	createCreditClient
} from './gql'

import {
	Clients,
	CashRegisters,
	DefaultOrder,
	DayOrder,
	DeliveryNotes
} from './'

import { IdCard, History } from 'media/icons'
import { isRouteDisabled } from 'sections/utils'

export default (t, rights) => ({
	id: '12',
	label: t('credit_client_section.caption'),
	typename: 'CreditClient',
	link: isRouteDisabled(rights, '12') ? null : 'kreditkunden',
	linkDisabled: isRouteDisabled(rights, '12'),
	recordsCounter: true,
	icon: IdCard,
	fieldsInLabel: [
		{ field: 'FA_Id', label: t('credit_client_section.strings.default_order_is_managed_in_faktura_assist') }
	],
	/*initialQueryVariables: {
		filter: {},
		params: {
			cursors: { limit: 100 },
			limit: 100, offset: 0, sort: []
		}
	},*/
	subsections: [{
		name: t('credit_client_section.sub_sections.client'),
		link: '',
		component: Clients,
		updateMutation: updateCreditClient.clients,
		fields: ['clientNumber', 'isActive', 'name', 'deliveryAdress', 'isNoActiveOnClient', 'FA_Id', 'shopId']
	}, {
		name: t('credit_client_section.sub_sections.cash_registers'),
		link: 'kassen',
		component: CashRegisters
	}, {
		name: t('credit_client_section.sub_sections.default_order'),
		queryItemIdPath: 'items[0].creditClientId',
		link: 'vorgabebestellung',
		component: DefaultOrder
	}, {
		name: t('credit_client_section.sub_sections.day_order'),
		link: 'tagesbestellung',
		component: DayOrder
	}, {
		name: t('credit_client_section.sub_sections.delivery_notes'),
		link: 'lieferscheine',
		component: DeliveryNotes
	}],
	itemActions: [{
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}/*, {
		label: t('credit_client_section.strings.history'),
		Icon: History,
		iconStyles: `margin-bottom: 6px;`,
		modalComponent: CardImport
	}*/],
	columns: creditcardList(t),
	listQuery: listCreditClients,
	itemQuery: getCreditClient,
	createMutation: createCreditClient,
	FilterComponent,
	requiredFields: ['name', 'clientNumber'],
	newRecordsDefaults: {
		taxSystem: 1,
		isActive: true
	},
	addNewRecord: true
})
